export interface IUserInfo {
    businessPhones: string[];
    displayName: string;
    givenName: string;
    jobTitle: string;
    mail: string;
    mobilePhone?: string | null;
    officeLocation?: string | null;
    preferredLanguage?: string | null;
    surname: string;
    userPrincipalName: string;
    id: string;
}

export interface IGraphUserName {
    id: string;
    displayName: string;
}

export interface IGraphUserInfo extends IGraphUserName {
    type: "user";
    businessPhones: string[];
    givenName: string;
    jobTitle: string;
    mail: string;
    mobilePhone?: string | null;
    officeLocation?: string | null;
    preferredLanguage?: string | null;
    surname: string;
    userPrincipalName: string;
}

export interface IGraphGroupInfo {
    type: "group";
    id: string;
    displayName: string;
    mail?: string | null;
    description?: string | null;
}

export type IGraphPickerItem = IGraphUserInfo | IGraphGroupInfo;

export interface IGraphResponse<T> {
    value?: T;
}

export interface IProfilePicture {
    imageUrl: string;
    name: string;
}

export enum EThemeName {
    DarkTheme = "dark",
    LightTheme = "light"
}

export interface ICreateConfigurationInfo {
    appId: string;
    tenantId?: string;
    isEnabled: boolean;
    userIds?: string[];
    groupIds?: string[];
    description?: string
    settingsData?: SettingsData;
}

export interface IConfigurationInfo {
    id: string;
    appId: string;
    tenantId: string;
    isEnabled: boolean;
    userIds?: string[];
    groupIds?: string[];
    lastUpdated?: string;
    description?: string
    settingsData: SettingsData;
}

export type SettingsData = Record<string, SettingValueType>;

export type SettingValueType = boolean | string | number;

export interface ISetting {
    key: string;
    name: string;
    value: SettingValueType;
}

export interface IConfigurationEntity {
    key: string;
    name: string;
    shortDescription?: string;
    defaultValue: SettingValueType;
    type: ConfigurationEntityType;
}

export type ConfigurationEntityType = "string" | "boolean" | "number" | "URL";

export enum EConfigurationInfoTab {
    Overview = "overview",
    Settings = "settings",
    Users = "users"
}

export interface IIdentityInfo {
    "@odata.context": string;
    id: string;
    displayName: string;
    mail: string;
    description?: string;
}

export interface IUserDetail {
    type: "user";
    id: string;
    displayName: string;
    email?: string;
}

export interface IGroupDetail {
    type: "group";
    id: string;
    displayName: string;
    email?: string;
    description?: string;
}

export interface IIdentityDetails {
    userDetails: IUserDetail[];
    groupDetails: IGroupDetail[];
}

export type IdentityDetail = IUserDetail | IGroupDetail

export enum EUserSelection {
    Organization = "org",
    User = "user",
    Group = "group"
}

export enum EAppDisplayName {
    MacroViewMail = "MacroView Mail",
    DMSNext = "DMS Next"
}

export enum EAppId {
    Mail = "Mail",
    DMSNext = "DMSNext"
}

export const configurableApplication: Record<EAppId, string> = {
    [EAppId.Mail]: EAppDisplayName.MacroViewMail,
    [EAppId.DMSNext]: EAppDisplayName.DMSNext,
};

export const AppIdsMap: Record<string, EAppId> = {
    [EAppDisplayName.MacroViewMail]: EAppId.Mail,
    [EAppDisplayName.DMSNext]: EAppId.DMSNext
};

export interface IGraphBatchRequest {
    requests: IBatchRequest[];
}

export interface IBatchRequest {
    id: string;
    method: string;
    url: string;
}

export interface IResponseBody {
    error?: Error;
    value?: unknown;
}

export interface IGraphBatchResponse {
    responses: IBatchResponse[];
}

export interface IBatchResponse {
    id: string;
    status: number;
    headers?: Headers;
    body?: IResponseBody | null | unknown;
}

